<template>
    <div :class="$style['share-mail']">
        <transition name="fade" mode="out-in">
            <PopupResult key="result"
                         v-if="isSuccess || isError"
                         :email="email"
                         :isSuccess="isSuccess"
                         :isError="isError"/>

            <div v-else key="base" class="share-mail__base">
                <div :class="$style['share-mail__title']">Отправить на почту</div>

                <form :action="action"
                      :method="method"
                      :class="$style['share-mail__content']"
                      @submit.prevent="send">
                    <input type="hidden" name="message_bot" v-model="bot">
                    <div :class="$style['share-mail__input']">
                        <Input name="email"
                               type="email"
                               v-model="email"
                               placeholder="E-mail адрес"
                               :required="true"/>
                    </div>

                    <div :class="$style['share-mail__person']">
                        <Checkbox name="person"
                                  v-model="person"
                                  :required="true">
                            Я согласен с <a :href="personLink">условиями обработки данных</a>
                        </Checkbox>
                    </div>

                    <div :class="$style['share-mail__submit']">
                        <Button type="submit">Отправить заявку</Button>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios';
    import Button from '../Button/Button';
    import Checkbox from '../forms/Checkbox/Checkbox';
    import Input from '../forms/Input/Input';
    import PopupResult from '../PopupResult/PopupResult';

    export default {
        components: {
            Button,
            Checkbox,
            Input,
            PopupResult
        },

        props: ['personLink', 'isSuccess', 'isError'],

        data: () => ({
            action: '/ajax/api.php',
            method: 'post',
            email: '',
            person: true,
            bot: '',
            request: {
                isSend: false
            }
        }),

        methods: {
            send() {
                const sendData = this.collectData();

                axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                axios[this.method](this.action, sendData)
                    .then((response) => {
                        const status = response.data.request.status;
                        this.request.isSend = true;

                        if (status) {
                            this.sendIsSuccess();
                        } else {
                            throw new Error('Ошибка на сервере');
                        }
                    })
                    .catch((error) => {
                        this.sendIsError();
                        console.error(error); // eslint-disable-line
                    });
            },

            collectData() {
                const sendData = new FormData();
                sendData.append('event', 'share');
                sendData.append('email', this.email);
                sendData.append('link', window.location.href);
                sendData.append('message_bot', this.bot);

                return sendData;
            },

            sendIsSuccess() {
                this.$emit('formSuccess');
            },

            sendIsError() {
                this.$emit('formError');
            }
        }
    }
</script>

<style lang="scss" module>
    @import "./ShareMail";
</style>
